var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-folder-48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 9H16.5L13.5 6H6C4.35 6 3 7.35 3 9V15H33V12C33 10.35 31.65 9 30 9Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 9H6C4.35 9 3 10.35 3 12V27C3 28.65 4.35 30 6 30H30C31.65 30 33 28.65 33 27V12C33 10.35 31.65 9 30 9Z",
    fill: "#FFDF80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.cc607ad360d7279a0b8f5380d715d618.svg";
export { ForwardRef as ReactComponent };